import { useMutation } from '@tanstack/react-query';
import { api } from '@/lib/api-client';

type ExportResponse = {
  exportedAt: string;
  entries: {
    pieceName: string;
    arrangementName: string;
    keyName: string | null;
    formName: string | null;
    masteryLevelName: string | null;
    queueStatusName: string;
  }[];
};

type ImportResponse = {
  imported: number;
  skipped: number;
};

type ImportRequest = {
  entries: {
    pieceName: string;
    arrangementName: string;
    keyName?: string;
    formName?: string;
    masteryLevelName?: string;
    queueStatusName?: string;
  }[];
};

export function useExportRepertoire(): ReturnType<typeof useMutation<ExportResponse, Error, void>> {
  return useMutation({
    mutationFn: () => api.fetch<ExportResponse>('/repertoire/export'),
  });
}

export function useImportRepertoire(): ReturnType<typeof useMutation<ImportResponse, Error, ImportRequest>> {
  return useMutation({
    mutationFn: (data: ImportRequest) =>
      api.fetch<ImportResponse>('/repertoire/import', {
        method: 'POST',
        body: JSON.stringify(data),
      }),
  });
}
